import { Dashboard } from "../components/dashboard/dashboard";

export const ProjectListView = () => {
  return <Dashboard />;
};
